module.exports = __webpack_public_path__ + "media/images/entreprise-footer-4-d56f144e48e95d2493d0ec49e06dc5c8.png";